import React, {Component, Fragment} from 'react';
import {withTranslation} from 'react-i18next';
import {Helmet} from "react-helmet";
import {
  HeroBlock,
  GelContentContainer,
  GelContentRow,
  GelContentColumn,
  ApiPager,
  Role,
  Link,
  withFlashState, CheckboxElement, ButtonSecondary, Controls, Notices, FormErrorSummary, withCourseContactApi
} from "cw-styleguide-react";
import {route} from "../../../routes";
import ContactsManageFilterForm from "../components/ContactsManageFilterForm";
import withAssets from "../../../components/hoc/withAssets";
import {ROLE_STAFF} from "../../../constants";

class ContactsManageView extends Component {



  /**
   * Render.
   * @returns {JSX.Element}
   */
  render() {

    return (
      <Fragment>
        <Helmet>
          <title>{this.props.t('view.contacts.manage.title')}</title>
        </Helmet>

        <GelContentContainer>
          <h1>{this.props.t('local:view.contacts.manage.title')}</h1>
        </GelContentContainer>

        <HeroBlock>
          <p>{this.props.t('local:view.contacts.manage.introduction')}</p>
        </HeroBlock>

        <GelContentContainer>

          <Notices messages={this.props.messages} />

          <FormErrorSummary errors={this.props.formErrors}/>

          {/* Display the page control buttons */}
          <Controls>
            <ButtonSecondary url={route('contactsCreate')} title={this.props.t('local:view.contacts.manage.controls.create')}>{this.props.t('local:view.contacts.manage.controls.create')}</ButtonSecondary>

            <Role roles={[ROLE_STAFF]}>
              <ButtonSecondary disabled={!this.props.selected.size} onClick={() => {this.props.toggleModal(['bulkDelete'], true)}} title={this.props.t('local:view.contacts.manage.controls.delete')}>{this.props.t('local:view.contacts.manage.controls.delete')}</ButtonSecondary>
            </Role>

            <ButtonSecondary disabled={!this.props.selected.size} onClick={() => {this.props.toggleModal(['bulkArchive'], true)}} title={this.props.t('local:view.contacts.manage.controls.archive')}>{this.props.t('local:view.contacts.manage.controls.archive')}</ButtonSecondary>
            <ButtonSecondary disabled={!this.props.selected.size} onClick={() => {this.props.toggleModal(['bulkRollback'], true)}} title={this.props.t('local:view.contacts.manage.controls.rollback')}>{this.props.t('local:view.contacts.manage.controls.rollback')}</ButtonSecondary>
          </Controls>

          {/* Training provider cannont delete or archive. */}

          <GelContentRow>
            <GelContentColumn xs={12} sm={12} md={4} lg={4} mdPush={8} lgPush={8}>
              <ContactsManageFilterForm values={this.props.filterValues} handleChange={this.props.handleChange} handleSubmit={this.props.handleSubmit} handleReset={this.props.handleReset} />
            </GelContentColumn>

            <GelContentColumn xs={12} sm={12} md={8} lg={8} mdPull={4} lgPull={4}>
              <ApiPager api={this.props.courseContactApiGetEndpoint('course_contact_api_contacts_q')}
                        filters={{
                          statuses: this.props.filterValues.status,
                          contactName: this.props.filterValues.contactName,
                          email: this.props.filterValues.email,
                          atlasAccountId: this.props.filterValues.atlasAccountId,
                          confirmationDate: this.props.filterValues.confirmationDate,
                        }}
                        autoReload={false}
                        sortOptions={[
                          {
                            value: 'rel',
                            label: this.props.t('styleguide:forms.order.options.rel')
                          },
                          {
                            value: 'asc',
                            label: this.props.t('styleguide:forms.order.options.asc')
                          },
                          {
                            value: 'desc',
                            label: this.props.t('styleguide:forms.order.options.desc')
                          }
                        ]}
                        handleStateChange={this.props.handleStateChange}
                        initialOrder={this.props.filterValues['order']}
                        initialPage={this.props.filterValues['page']}
                        initialGroupSize={this.props.filterValues['groupSize']}
                        reloadKey={this.props.reloadKey}
                        onReloadResetPage={true}
                        noResultsText={this.props.t('styleguide:messages.noResults')}
                        hasResultsText={''}
                        table={true}
                        tableHeader={() => (
                          <tr>
                            <th>{this.props.t('local:view.contacts.manage.tableHeader.select')}</th>
                            <th>{this.props.t('local:view.contacts.manage.tableHeader.name')}</th>
                            <th>{this.props.t('local:view.contacts.manage.tableHeader.email')}</th>
                            <th>{this.props.t('local:view.contacts.manage.tableHeader.status')}</th>
                          </tr>
                        )}
                        render={(contact) => (<tr>
                          <td><CheckboxElement onChange={this.props.handleBulkCheckbox} checked={this.props.selected.has(contact.id) } value={contact.id}/></td>
                          <td>  <Link to={route('contactsEdit' ,{"contact" : contact.id})}>{contact.contactName}</Link></td>
                          <td> {contact.email}</td>
                          <td>{this.props.courses.getStatusName(contact.status)}</td>
                        </tr>)}/>
            </GelContentColumn>
          </GelContentRow>
        </GelContentContainer>
      </Fragment>

    )
  }

}

export default withCourseContactApi(process.env)(withAssets(withFlashState(withTranslation('local')(ContactsManageView))));
